import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";

interface State {
  offline: boolean;
  vocab: boolean;
}

export const useLicenseStore = defineStore("license", () => {
  const state = reactive<State>({
    offline: false,
    vocab: false
  });

  const setLicenses = (licenses: Partial<State>) => Object.assign(state, { ...licenses });

  return {
    ...toRefs(state),

    setLicenses
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLicenseStore, import.meta.hot));
}
